export type { Props } from './text-area';
export { default as TextArea } from './text-area';
